
import ItemsCount from "@/components/ItemsCount.vue";
import Acceptability from "@/components/Acceptability.vue";
import { getFilteredItemsBy, c_alternativesIds } from "@/store";
import { computed, defineComponent, PropType, ref, toRefs } from "vue";
import { NormalizedAim, NormalizedArgument } from "@/@types";
export default defineComponent({
  props: {
    aim: {
      type: Object as PropType<NormalizedAim>,
      required: true,
    },
    criterionId: {
      type: Number,
      required: true,
    },
  },

  setup(props) {
    const { aim, criterionId } = toRefs(props);

    const aimsItems = computed(() => {
      let obj: { [key: string]: NormalizedArgument[] } = {};
      c_alternativesIds.value.forEach((alternativeId) => {
        const items = getFilteredItemsBy({
          alternative: alternativeId,
          aim: aim.value.id,
          criterion: criterionId.value,
        });

        obj[alternativeId] = items;
      });
      return obj;
    });

    const totalItems = computed(() => {
      return Object.values(aimsItems.value).reduce((acc, items) => {
        return acc + items.length;
      }, 0);
    });

    return {
      c_alternativesIds,
      aimsItems,
      totalItems,

      getFilteredItemsBy,
    };
  },
  // props: ["aim"],
  components: {
    Acceptability,
    ItemsCount,
  },
  // computed: {

  // alternativeItems: function() {
  //   return {
  //     1: getFilteredItemsBy({
  //       alternative: 1,
  //       aim: this.aim.id
  //     }),
  //     2: getFilteredItemsBy({
  //       alternative: 2,
  //       aim: this.aim.id
  //     })
  //   };
  // }
  // },
  // methods: {

  // }
});
